import { DateTime } from 'luxon';
import { TimeWindow } from '../types';

export const fakeTimeWindowFactory = {
  createTimeWindow: (timeWindow: Partial<TimeWindow> = {}): TimeWindow => ({
    start: new Date(),
    end: DateTime.fromJSDate(new Date()).plus({ hours: 8 }).toJSDate(),
    ...timeWindow,
  }),
};

export const fakeTimeWindow: TimeWindow =
  fakeTimeWindowFactory.createTimeWindow();
